import { useEffect, useState } from 'react'
import { Quill } from 'react-quill'
import { ClearImageResize, PasteInterceptor, SocialEmbed, SocialEmbedder } from 'shared/quill/modules'
import MagicUrl from 'quill-magic-url'
import BlotFormatter from 'quill-blot-formatter/dist/BlotFormatter'

const useInitializationQuill = (): { isQuillInitialized: boolean } => {
  const [isQuillInitialized, setQuillInitialized] = useState(false)

  const reloadCustomEditorIcons = (icons: any) => {
    icons['bold'] = '<i class="fal fa-bold" title="bold" />'
    icons['italic'] = '<i class="fal fa-italic" title="italic" />'
    icons['underline'] = '<i class="fal fa-underline" title="underline" />'
    icons['strike'] = '<i class="fal fa-strikethrough" title="strikethrough" />'
    icons['color'] = '<i class="fal fa-tint" title="color picker" />'
    icons['background'] = '<i class="fal fa-fill-drip" title="background picker" />'
    icons['link'] = '<i class="fal fa-link" title="link" />'
    icons['image'] = '<i class="fal fa-images" title="link" />'
    icons['list']['bullet'] = '<i class="fal fa-list-ul" title="unordered list" />'
    icons['list']['ordered'] = '<i class="fal fa-list-ol" title="ordered list" />'
    icons['embed'] = `
        <i class="fab fa-youtube" title="Embed youtube" /></i>
        <i class="fab fa-facebook-f" title="Embed facebook"></i>
        <i class="fab fa-instagram" title="Embed instagram"></i>
        <i class="fab fa-twitter" title="Embed twitter"></i>
        <i class="fab fa-tiktok" title="Embed tiktok"></i>
      `
    icons['clean'] = '<i class="fal fa-eraser" title="clear formatting" />'
  }

  useEffect(() => {
    if (!isQuillInitialized) {
      const icons = Quill.import('ui/icons')
      reloadCustomEditorIcons(icons)

      Quill.register('modules/pasteInterceptor', PasteInterceptor)
      Quill.register('modules/socialEmbedder', SocialEmbedder)
      Quill.register('modules/magicUrl', MagicUrl)
      Quill.register('modules/blotFormatter', BlotFormatter)
      Quill.register('modules/clearImageResize', ClearImageResize)
      Quill.register(SocialEmbed)

      setQuillInitialized(true)
    }
  }, [isQuillInitialized])

  return { isQuillInitialized }
}

export default useInitializationQuill
